import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { PasskeyRecoveryPage as PasskeyRecovery } from '@egw/features-auth'

export const PasskeyRecoveryPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.recovery.title')} />
      <PasskeyRecovery />
    </Layout>
  )
}
